import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Skeleton from 'components/Skeleton';

/**
 * Loading placeholder that mirrors the desktop HomeOfferCard layout
 * (see ./Card.js and ./CardContent.js): store on top, centered 120x120
 * product image, user row, two-line title, price and a right-aligned
 * reactions footer. Used as the LazyHydration `fallback` and as the
 * desktop half of the offers-list loading skeleton. Desktop-only — the
 * mobile layout is MobileOfferCard.
 */
const HomeOfferCardSkeleton = ({ className }) => (
  <div
    className={twMerge(
      'flex h-full select-none flex-col justify-between rounded-4 border border-neutral-high-200 bg-neutral-high-100 p-6 pb-3 dark:border-neutral-low-400 dark:bg-neutral-low-400',
      className
    )}
  >
    <div className="flex flex-col gap-5">
      {/* Loja */}
      <div className="flex items-center gap-2 pb-4">
        <Skeleton className="size-4 rounded-2" />
        <Skeleton className="h-4 w-24 rounded-2" />
      </div>
      {/* Imagem do produto (120x120, centralizada) */}
      <div className="flex justify-center">
        <Skeleton className="size-[120px] rounded-4" />
      </div>
      {/* Usuário, título e preço */}
      <div className="flex flex-col border-b border-neutral-high-300 pb-4 dark:border-neutral-high-400">
        {/* Avatar + nome à esquerda, tempo à direita */}
        <div className="mt-1 flex items-center justify-between">
          <div className="flex items-center gap-1">
            <Skeleton className="size-5 rounded-full" />
            <Skeleton className="h-3 w-16 rounded-2" />
          </div>
          <Skeleton className="h-3 w-10 rounded-2" />
        </div>
        {/* Título (2 linhas) */}
        <div className="mt-2 flex min-h-12 flex-col gap-2">
          <Skeleton className="h-4 w-full rounded-2" />
          <Skeleton className="h-4 w-3/4 rounded-2" />
        </div>
        {/* Preço */}
        <Skeleton className="mt-2 h-6 w-28 rounded-2" />
      </div>
    </div>
    {/* Footer: reações à direita — a pílula real tem 30px */}
    <div className="mt-3 flex w-full justify-end">
      <div className="flex items-center gap-2">
        <Skeleton className="h-[30px] w-9 rounded-full" />
        <Skeleton className="h-[30px] w-px" />
        <Skeleton className="h-[30px] w-9 rounded-full" />
      </div>
    </div>
  </div>
);

HomeOfferCardSkeleton.propTypes = {
  className: PropTypes.string,
};

export default HomeOfferCardSkeleton;
